// React
import React from 'react'

// Third Party
import { Helmet } from 'react-helmet'
import ReactMarkdown from 'react-markdown'
import { withRouteData } from 'react-static'
import SbEditable from 'storyblok-react'

// CSS
import './About.css'

/**
 * @param {string} title
 */
function transformTitleToURL(title) {
  const sanatizedTitle = title
    .toLowerCase()
    .replace(/ñ/g, 'n')
    .replace(/[,.]g/, '')

  const url = sanatizedTitle.replace(/\s+/g, '-')
  return url
}

/**
 * @typedef {{story: {
 *  content: {
 *    top: Array<{image: string, title: string, image_offset: string}>
 *    policies: Array<{title: string, description: string}>
 *  }
 * }}} PrivacyPolicyProps
 */

/**
 * @function
 * @param {PrivacyPolicyProps}
 */
function TermsConditionsAndPrivacyPolicy({ story }) {
  const { content } = story

  return (
    <div>
      <Helmet>
        <title>{content && content.top[0].title}</title>
      </Helmet>
      {content &&
        content.top &&
        content.top.map(el => (
          <SbEditable key={el._uid} content={el}>
            <div
              className='hero hero--small'
              style={{
                backgroundImage: `url(${el.image})`,
                backgroundPosition: `center ${el.image_offset ? `${el.image_offset}%` : '50%'}`,
              }}
            >
              <div className='hero__overlay' />
              <div className='wrapper'>
                <h1 className='hero__title hero--small__title'>{el.title}</h1>
              </div>
            </div>
          </SbEditable>
        ))}

      <div className='wrapper'>
        <div>
          {content &&
            content.policies &&
            content.policies.map((policy, idx) => {
              const currentPolicyNumber = idx + 1
              const url = transformTitleToURL(policy.title)

              return (
                <section className='my-2' key={idx}>
                  <h2>
                    {currentPolicyNumber}. {policy.title}
                    <a
                      id={url}
                      href={`#${url}`}
                      className='ml-2 no-underline text-light hover:text-green-500 transition-all duration-300'
                    >
                      #
                    </a>
                  </h2>

                  <ReactMarkdown
                    className='text-left'
                    source={policy.description}
                    renderers={{
                      strong: ({ node, ...props }) => (
                        <strong className='font-bold' {...props} />
                      ),
                    }}
                  />
                </section>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default withRouteData(TermsConditionsAndPrivacyPolicy)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/TermsConditionsAndPrivacyPolicy.jsx